/* eslint-disable no-param-reassign */
import type { Data } from '../../specProcessor';
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as StackBoardBarLayerSpec } from '../../../../layer/preset/bar/stackBoardBar';
import * as utils from '../../../../util';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';

export type Spec = BaseSpec;

// 扩展ILayerTypeSpec以包含__isEncodingValid属性
interface StackBoardBarLayerTypeWithFields extends ILayerTypeSpec {
  __isEncodingValid?: boolean;
}

type StackBoardBarLayerType = StandardChartLayerSpec &
  StackBoardBarLayerSpec &
  StackBoardBarLayerTypeWithFields;

// 创建叠加看板柱状图数据类型验证器
const validateStackBoardBarDataTypes = createDataTypeValidator('stackBoardBar', [
  { field: 'x', type: 'string' },
  { field: 'y', type: 'number' },
  { field: 'z', type: 'array' }
]);

// 创建叠加看板柱状图编码验证器
const validateStackBoardBarEncoding = createEncodingValidator([
  { field: 'x' },
  { field: 'y' },
  { field: 'z' }
]);

// 额外的检查函数
const additionalStackBoardBarChecks = (layer: StackBoardBarLayerType, data: Data) => {
  const { encoding, type } = layer;
  const dataIndex = layer.dataIndex || 0;
  const values = data[dataIndex]?.values || [];

  // 要求至少有2条数据
  if (values.length <= 1) {
    utils.logger.warn(
      'warning',
      `The "${type}" chart requires at least 2 data points to be meaningful`
    );
  }

  if (!values.length || !encoding.z) {
    return;
  }

  // 检查趋势数据
  const zField = encoding.z;
  const insufficientTrendData = values.some(item => {
    const zData = item[zField];
    return !Array.isArray(zData) || zData.length < 2;
  });

  if (insufficientTrendData) {
    utils.logger.warn(
      'warning',
      `Some trend data in the "z" field of the "${type}" layer has less than 2 points, which may not show a meaningful trend`
    );
    // 这只是警告，不影响图表渲染
  }
};

// 创建并导出叠加看板柱状图处理器
export const stackBoardBar = createLayerProcessor<StackBoardBarLayerType>(
  'stackBoardBar',
  validateStackBoardBarEncoding,
  validateStackBoardBarDataTypes,
  additionalStackBoardBarChecks
);
